export default "__VITE_ASSET__BJyDlnuu__"